import { AUTH_HEADERS, BASE_URL } from "./BaseProxy";

const STORY_INFO_URL = `${BASE_URL}story/info/`;

export interface StoryInfo {
  id: number;
  name: string;
  age: string;
  learning_style: string;
  enneagram: number;
  attachmentTheory: number;
  proChange: number;
  changeExperience: number;
  changeLikelyhood: number;
  authorRole: string;
  recordingLocation: string;
  recordingCity: string;
  recordingProvince: string;
  recordingYear: string;
  quote: string;
}

export type StoryResult = StoryInfo | { error: string; trackId: string };

export const getStoryInfo = async (trackId: string): Promise<StoryResult> => {
  const url = `${STORY_INFO_URL}?storyId=${encodeURIComponent(trackId)}`;
  return await fetch(url, {
    method: "GET",
    mode: "cors",
    headers: AUTH_HEADERS,
  })
    .then((data) => data.json())
    .then((data) =>
      "error" in data
        ? { error: (data as any).error as string, trackId }
        : (data as StoryInfo)
    )
    .catch(() => ({ error: "Network error", trackId }));
};
